(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ghost-home-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-ghost-newsletter]');
    if (!section) return;

    var form = section.querySelector('[data-ghost-newsletter-form]');
    var submit = section.querySelector('[data-ghost-newsletter-submit]');
    if (!form || !submit) return;

    var label = submit.querySelector('[data-ghost-newsletter-submit-label]');
    var loading = submit.querySelector('[data-ghost-newsletter-submit-loading]');
    var webhookUrl = section.getAttribute('data-webhook-url');

    form.addEventListener('submit', function() {
      submit.disabled = true;
      if (label) label.hidden = true;
      if (loading) loading.hidden = false;

      if (!webhookUrl) return;

      var firstNameInput = form.querySelector('[name="contact[first_name]"]');
      var emailInput = form.querySelector('[name="contact[email]"]');
      var firstName = firstNameInput ? String(firstNameInput.value || '').trim() : '';
      var email = emailInput ? String(emailInput.value || '').trim().toLowerCase() : '';

      fetch(webhookUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          firstName: firstName,
          name: firstName,
          email: email,
          source: 'newsletter',
          type: 'lead',
          page_url: window.location.href
        }),
        keepalive: true
      }).catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
